<template>
  <div class="s3">
    <div class="container">
      <img src="@/assets/home/s3/Productsystem.png" class="Productsystem" alt="" />
      <div class="product-wrapper">
        <div class="product-item" v-for="item in iconList" :key="item.id">
          <div class="img-box">
            <img :src="item.icon" alt="" class="icon" />
          </div>
          <div class="msg">
            <img :src="item.title" alt="" class="title" />
            <p>{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconList: [
        {
          id: 3,
          icon: require("@/assets/home/s3/3.png"),
          title: require("@/assets/home/s3/33.png"),
          text: `香水柠檬，鸭屎香乌龙茶，只需简单粗暴的爆锤，一定要捶打的恰到位呢？不然香味可出不来，嘿嘿，还有小伙伴俗称这款饮品为“暴打渣男”呢`,
        },
        {
          id: 1,
          icon: require("@/assets/home/s3/1.png"),
          title: require("@/assets/home/s3/11.png"),
          text: `只选用100%零添加生椰乳30CC浓缩咖啡，轻吟本真只要你敢尝试，不怕你不爱上`,
        },
        {
          id: 2,
          icon: require("@/assets/home/s3/2.png"),
          title: require("@/assets/home/s3/22.png"),
          text: `当咖啡与牛奶出现碰撞，还有香草的捧场，甜蜜之情自然溢于言表，不过顺便透露点，为此埋单的大多数是一对对的小哥哥小姐姐们`,
        },
        {
          id: 6,
          icon: require("@/assets/home/s3/6.png"),
          title: require("@/assets/home/s3/66.png"),
          text: `选用新鲜牛奶加上现萃玫瑰风味红茶，小以发泡，再打上鲜奶雪顶，喝前轻挑一口鲜奶，难道你不心动？`,
        },
        {
          id: 4,
          icon: require("@/assets/home/s3/4.png"),
          title: require("@/assets/home/s3/44.png"),
          text: `精选南美洲，非洲进口咖啡豆，辅以冠军配方，精心烘焙，大师萃取，简单纯粹，是爱喝咖啡宝宝们的首选，悄悄的告诉你，不加糖才是真爱吆`,
        },
        {
          id: 5,
          icon: require("@/assets/home/s3/5.png"),
          title: require("@/assets/home/s3/55.png"),
          text: `新鲜西瓜，100%零添加生椰乳，还有那么点茉莉花绿茶，就简单的合在一起搅打，出品时再来点绿茶冻冻，哈哈，夏天谁能不爱？`,
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.s3 {
  width: 100%;
  // height: 867.29px;
  background: #e6328d;
  padding-top: 90px;
  // box-sizing: border-box;
  padding-bottom: 160px;
  margin: 0 auto;
  .container {
    // width: 1600px;
    margin: 0 auto;
    text-align: left;

    .Productsystem {
      width: 473px;
      height: 52px;
    }
    .product-wrapper {
      // width: 1600px;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      align-content: space-between;
      margin: 0 auto;
      margin-top: 80px;
      .product-item {
        width: 467px;
        // height: 198.65px;
        display: flex;

        .img-box {
          width: 240px;
          height: 212px;
          // margin-top: ceil(198.65px - 212px);

          .icon {
            width: 240px;
            height: 212px;
          }
        }
        .msg {
          margin-left: 25.5px;
          .title {
            width: 161px;
            height: 59px;
            margin-top: 37px;
          }
          p {
            color: #fff;
            // white-space: pre-wrap;
            text-align: justify;
            line-height: 20px;
            font-size: 14px;
            margin-top: 14px;
          }
        }
      }
    }
  }
}

@media screen {
  @media (min-width: 1617px) {
    .s3 {
      min-width: 1600px;
    }
    .container {
      width: 1600px;
      height: 617.29px;

      .product-wrapper {
        width: 1550px;
        height: 487.29px;
        justify-content: space-between;
      }
    }
  }

  @media (min-width: 1574px) and (max-width: 1616px) {
    .container {
      max-width: 1600px;
      width: 90%;
      height: 617.29px;

      .product-wrapper {
        width: 100%;
        height: 487.29px;

        justify-content: space-between;
      }
    }
  }

  @media (min-width: 1201px) and (max-width: 1573px) {
    .container {
      max-width: 1600px;
      width: 90%;
      .product-wrapper {
        width: 100%;
        height: 700px;

        justify-content: space-between;
      }
    }
  }

  @media (max-width: 1200px) {
    .s3 {
      width: 1200px;
    }
    .container {
      width: 1083px;
      .product-wrapper {
        width: 1083px;
        justify-content: space-between;

        height: 700px;
      }
    }
  }
}
</style>
